import { useCallback } from "react";
import { customFieldsRequest } from "./api";
import useCustomFieldsResource from "./useCustomFieldsResource";

const useAdditionalDetails = ({
  teamId,
  leadId,
  generation,
  enabled,
  revalidateOnFocus = true,
}) => {
  const path = `/leads/${encodeURIComponent(leadId)}/custom_fields`;
  const resource = useCustomFieldsResource({
    teamId,
    generation,
    enabled,
    retainOnFocus: true,
    revalidateOnFocus,
    handleUnavailable: true,
    path,
  });
  const save = useCallback(
    (changes, snapshot) =>
      customFieldsRequest({
        teamId,
        path: `${path}/values`,
        method: "PUT",
        handleUnavailable: true,
        body: {
          changes,
          catalog_revision: snapshot.catalog_revision,
          values_revision: snapshot.values_revision,
        },
      }),
    [teamId, path],
  );
  return { ...resource, save };
};

export default useAdditionalDetails;
